// Attribution + context helpers for the embed. Pure given their inputs —
// storage handles are passed in, never touched at import time (SSR-safe).
// Shapes must match the server's cleanContext whitelist exactly
// (functions/src/lib/formsPipeline.js).

export const FIRST_TOUCH_KEY = 'cnf-first-touch'

export function parseUtm(search) {
  const p = new URLSearchParams(search || '')
  const g = (k) => p.get('utm_' + k) || ''
  return { source: g('source'), medium: g('medium'), campaign: g('campaign'), term: g('term'), content: g('content') }
}

/** Existing valid record wins (first touch is immutable); else mint a new one. */
export function buildFirstTouch(existingJson, { utm, referrer, landingPage, now }) {
  if (existingJson) {
    try {
      const rec = JSON.parse(existingJson)
      if (rec && typeof rec === 'object' && typeof rec.ts === 'number') return { record: rec, isNew: false }
    } catch { /* corrupt — fall through to mint */ }
  }
  return { record: { utm, referrer: referrer || '', landingPage: landingPage || '', ts: now }, isNew: true }
}

export function buildContext({ pageUri, pageName, referrer, utm, firstTouch }) {
  return {
    pageUri: pageUri || '', pageName: pageName || '', referrer: referrer || '',
    utm, firstTouch: firstTouch || null,
  }
}

export function viewDedupeKey(slug, path) {
  return `cnf-view:${slug}:${path}`
}

export function safeGet(storage, key) {
  try { return storage.getItem(key) } catch { return null }
}

export function safeSet(storage, key, value) {
  try { storage.setItem(key, value); return true } catch { return false }
}
